module.exports = __webpack_public_path__ + "static/media/ae.956b4f4b.svg";